export const updateDependentFieldKey = (dependentField, updateKey, updateValue) => Object.assign({}, dependentField, {
  [updateKey]: updateValue
});
export default updateDependentFieldKey;